import React from "react";

export const fixUrl = (url: string) => {
  if (!url.match(/^https?:\/\//i) && url) {
    url = "https://" + url;
  }

  return url;
};

const LogoBaseLink: React.FC<
  React.PropsWithChildren<{
    href: string;
    tabIndex?: number;
  }>
> = ({ href, tabIndex, children }) => {
  return (
    <a
      className="c-social-media-list__link"
      href={fixUrl(href)}
      target="_blank"
      tabIndex={tabIndex}
      rel="noreferrer"
    >
      {children}
    </a>
  );
};

export default LogoBaseLink;
